import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Location } from '@angular/common';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { PerfectScrollbarService } from '../../_services/perfect-scrollbar.service';
import { filter, Subscription } from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-layout',
    templateUrl: './admin-layout.component.html'
})

export class AdminLayoutComponent implements OnInit {
    private lastPoppedUrl!: string | undefined;
    private yScrollStack: number[] = [];
    url: any;
    location: Location;
    private _router!: Subscription;
    // url: string;

    @ViewChild('sidebar') sidebar: any;
    @ViewChild(NavbarComponent) navbar!: NavbarComponent;
    constructor(
        private router: Router, 
        location: Location,
        private perfectScrollbarService: PerfectScrollbarService
    ) {
        this.location = location;
    }

    ngOnInit() {
        if (typeof document !== 'undefined') {
            const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

            this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationStart) {
                    if (event.url != this.lastPoppedUrl)
                        this.yScrollStack.push(window.scrollY);
                } else if (event instanceof NavigationEnd) {
                    if (event.url == this.lastPoppedUrl) {
                        this.lastPoppedUrl = undefined;
                        const scrollValue = this.yScrollStack.pop()!;
                        window.scrollTo(0, scrollValue);
                    }
                    else
                        window.scrollTo(0, 0);
                }
            });
            // Handle navigation end events: reset scroll, close sidebar, and update page header
            this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
                elemMainPanel.scrollTop = 0;
                elemSidebar.scrollTop = 0;
                this.navbar.sidebarClose();
            });

            // activate perfectScrollbar function when running on windows
            if(this.perfectScrollbarService.isWindowsOS()) {
                // Initialize PerfectScrollbar using shared service
                this.perfectScrollbarService.initializeMainPanel();
                this.perfectScrollbarService.initializeModalDialog();
                this.perfectScrollbarService.initializeScrollableList();
                this.perfectScrollbarService.initializeAgGrid();
                
                // Update scrollbars when DOM changes
                setTimeout(() => {
                    this.perfectScrollbarService.updateAll();
                }, 100);
            }
        }

    }
    public isMap() {
        if (this.location.prepareExternalUrl(this.location.path()) == '#/maps/fullscreen') {
            return true;
        }
        else {
            return false;
        }
    }
}
